import { useState, memo } from "react";
import clsx from "clsx";
import { useHistory } from "react-router";

import { makeStyles } from "@material-ui/styles";
import { Paper, List, ListItem, ListItemText } from "@material-ui/core";

import { ALLOWLIST_PAGE_BASE_PATH } from "./common";

const useListStyles = makeStyles((theme) => ({
  ruleListPaper: {
    height: "100%",
    width: 275,
    overflowY: "auto",
    flexShrink: 0,
    borderRadius: 0,
  },
  ruleList: {
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  listItem: {
    borderBottom: "1px solid #eeeeee",
    overflow: "hidden",
    transition: "flex .5s ease-in-out",
  },

  active: {
    backgroundColor: "#C5CAE9",
    fontWeight: 550,
    "&:hover": {
      backgroundColor: "#C5CAE9",
    },
  },
}));

function RulesList({ rules, activeRuleID, searchString }) {
  const classes = useListStyles();
  const history = useHistory();

  rules =
    rules &&
    rules.filter((rule) =>
      (rule.name || "").toLowerCase().includes(searchString.toLowerCase())
    );

  const onSelectRule = ({ id }) => {
    history.push(`${ALLOWLIST_PAGE_BASE_PATH}/${id}`);
  };

  return (
    <Paper className={classes.ruleListPaper}>
      <List disablePadding className={classes.ruleList}>
        {rules.map((rule) => (
          <ListItem
            key={rule.id}
            className={clsx(
              classes.listItem,
              activeRuleID === rule.id && classes.active
            )}
            button
            onClick={() => onSelectRule(rule)}
          >
            <ListItemText
              primary={rule.name}
              className="truncate"
              title={rule.name}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}

const RulesListMemo = memo(RulesList);

export default RulesListMemo;
